import React from "react"

const BackgroundBox = (props) => {
  return <p className="pl-5 mt-6 text-base leading-7 text-l6-text rounded-lg bg-l6-background">
    {props.children}
  </p>
}
export default BackgroundBox;